module.exports = __webpack_public_path__ + "img/new-whatsapp.bfe56124.svg";